import { environment } from '../../environments/environment'

/**
 * Check if running in beta environment
 */
export function isProdBetaEnvironment(): boolean {
  return environment.release_name === 'prod-ent0-ent0-beta'
}

/**
 * Check if running in production (non-beta)
 */
export function isProdEnvironment(): boolean {
  return environment.release_name === 'prod-ent0-ent0'
}

/**
 * Check if running in production or beta
 */
export function isProdOrBetaEnvironment(): boolean {
  return isProdEnvironment() || isProdBetaEnvironment()
}
